import React from "react";
import { toElementProps } from "../../Element";

export function SocialsStyles(params = {}) {
    return {
        "& .socials": {
            display: "flex",
            flexWrap: "wrap",
            gap: "8px",

            "& .social": {
                width: "24px",
                height: "24px",
                border: "none",
                borderRadius: "0",
                background: "center / 90% no-repeat",
                cursor: "pointer",

                transition: "all 250ms ease",

                "&:hover": {
                    backgroundSize: "100%",
                },

                "&.facebook": { backgroundImage: "url(/img/socials/facebook.svg)" },
                "&.linkedin": { backgroundImage: "url(/img/socials/linkedin.svg)" },
            },
        },
    };
}

export default function Socials(props) {
    const { socials } = props.variables;

    if (!Array.isArray(socials)) {
        console.warn("Socials is not array!");
        return null;
    }

    if (!socials || socials.length === 0) {
        return null;
    }

    const elProps = toElementProps(props, { className: ["socials"] });
    return (
        <div {...elProps}>
            {socials?.map(({ type, link /* , title */ }) => (
                <button
                    key={link}
                    className={`social ${type} ignore-global`}
                    onClick={() => window.open(link, "_blank")}
                />
            ))}
        </div>
    );
}
